import { StyleSheet, Dimensions, Platform } from "react-native";

import AppConfig from "../../../../config/AppConfig";
import AppTheme from "../../AppTheme";

const footerStyles = StyleSheet.create({
  footer: {
    width: Dimensions.get("window").width,
    maxWidth: "100%",
    backgroundColor: AppTheme.footer,
  },
  container: {
    height: 70,
    width: "94%",
    marginHorizontal: "3%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  base: {
    backgroundColor: AppTheme.footer,
    flexDirection: "row",
    justifyContent: "space-evenly",
    paddingHorizontal: 4,
    paddingVertical: 0,
    marginVertical: 0,
    shadowOpacity: 0.25,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: -1 },
    shadowRadius: 2,

    ...Platform.select({
      web: {
        width: "100%",
        maxWidth: AppConfig.MAX_WIDTH,
        margin: "auto",
      },
      ios: {
        paddingBottom: 44,
        minHeight: 80,
      },
    }),
  },
  pill: {
    paddingVertical: 4,
  },
  highlightFooter: {
    width: 55,
    height: 55,
    borderRadius: 100,
    backgroundColor: "#F8E585",
    shadowOpacity: 0.25,
    shadowOffset: { width: 0, height: 4 },
    shadowColor: "#000",
    shadowRadius: 4,
    elevation: 4,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
});

export default footerStyles;
